const RESERVA_DURACION_HORAS = 2;

export const haySolapamiento = (inicio1, fin1, inicio2, fin2) => {
  return inicio1 < fin2 && fin1 > inicio2;
};

export const hayConflictoConReserva = (inicioNueva, finNueva, inicioExistente, finExistente, margenAntes, margenDespues) => {
  const inicioConMargen = new Date(inicioExistente.getTime() - margenAntes * 60 * 1000);
  const finConMargen = new Date(finExistente.getTime() + margenDespues * 60 * 1000);
  return haySolapamiento(inicioNueva, finNueva, inicioConMargen, finConMargen);
};

export const encontrarSiguienteHueco = (
  inicioDeseado,
  finDeseado,
  reservasActivas,
  horasInhabiles,
  diasInhabiles,
  margenAntes,
  margenDespues
) => {
  const duracionReservaMinutos = (finDeseado - inicioDeseado) / (1000 * 60);
  const minimoMinutosLibres = duracionReservaMinutos + margenDespues;
  const minimoHorasLibres = minimoMinutosLibres / 60;

  let candidato = new Date(inicioDeseado);
  const maxIteraciones = 365 * 24;
  let iteraciones = 0;

  while (iteraciones < maxIteraciones) {
    const candidatoFin = new Date(candidato.getTime() + minimoHorasLibres * 60 * 60 * 1000);

    const fechaCandidato = candidato.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Europe/Madrid'
    });

    let conflictoInhabil = false;
    if (diasInhabiles && diasInhabiles.datos && diasInhabiles.datos[fechaCandidato]) {
      const horasInhabilesDia = diasInhabiles.datos[fechaCandidato];
      const diaCompletoInhabil = horasInhabilesDia.length === 24;

      if (diaCompletoInhabil) {
        conflictoInhabil = true;
        candidato = new Date(candidato.getTime());
        candidato.setDate(candidato.getDate() + 1);
        candidato.setHours(0, 0, 0, 0);
        iteraciones++;
        continue;
      }

      const horaCandidatoMadrid = parseInt(candidato.toLocaleString('es-ES', {
        hour: '2-digit',
        hour12: false,
        timeZone: 'Europe/Madrid'
      }));
      const horaFinMadrid = parseInt(candidatoFin.toLocaleString('es-ES', {
        hour: '2-digit',
        hour12: false,
        timeZone: 'Europe/Madrid'
      }));

      let ultimaHoraInhabil = -1;
      for (let hora = horaCandidatoMadrid; hora < horaFinMadrid ||
        (candidatoFin.getDate() !== candidato.getDate() && horaFinMadrid > 0); hora++) {
        if (horasInhabilesDia.includes(hora % 24)) {
          conflictoInhabil = true;
          ultimaHoraInhabil = Math.max(ultimaHoraInhabil, hora % 24);
        }
      }

      if (conflictoInhabil && ultimaHoraInhabil >= 0) {
        let siguienteHoraDisponible = -1;
        for (let h = ultimaHoraInhabil + 1; h < 24; h++) {
          if (!horasInhabilesDia.includes(h)) {
            siguienteHoraDisponible = h;
            break;
          }
        }

        if (siguienteHoraDisponible >= 0) {
          candidato.setHours(siguienteHoraDisponible, 0, 0, 0);
        } else {
          candidato.setDate(candidato.getDate() + 1);
          candidato.setHours(0, 0, 0, 0);
        }
        iteraciones++;
        continue;
      }
    }

    if (conflictoInhabil) {
      candidato = new Date(candidato.getTime() + 60 * 60 * 1000);
      iteraciones++;
      continue;
    }

    let conflictoReserva = false;
    let reservaConflictiva = null;
    for (const reserva of reservasActivas) {
      const reservaInicio = new Date(reserva.fecha_hora_inicio);
      const reservaFin = new Date(reserva.fecha_hora_fin);

      if (hayConflictoConReserva(candidato, candidatoFin, reservaInicio, reservaFin, margenAntes, margenDespues)) {
        conflictoReserva = true;
        reservaConflictiva = reserva;
        break;
      }
    }

    if (!conflictoReserva) {
      return candidato;
    }

    if (reservaConflictiva) {
      const reservaFin = new Date(reservaConflictiva.fecha_hora_fin);
      candidato = new Date(reservaFin.getTime() + margenDespues * 60 * 1000);
    } else {
      candidato = new Date(candidato.getTime() + 60 * 60 * 1000);
    }

    iteraciones++;
  }

  return null;
};

export const evaluarDisponibilidad = ({
  inicioReserva,
  finReserva,
  reservasActivas,
  datosInhabiles,
  margenAntes,
  margenDespues
}) => {
  let conflictoInhabil = false;
  const fechaReservaStr = inicioReserva.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Madrid'
  });

  if (datosInhabiles && datosInhabiles.datos && datosInhabiles.datos[fechaReservaStr]) {
    const horasInhabiles = datosInhabiles.datos[fechaReservaStr];

    const horaInicioMadrid = parseInt(inicioReserva.toLocaleString('es-ES', {
      hour: '2-digit',
      hour12: false,
      timeZone: 'Europe/Madrid'
    }));
    const horaFinMadrid = parseInt(finReserva.toLocaleString('es-ES', {
      hour: '2-digit',
      hour12: false,
      timeZone: 'Europe/Madrid'
    }));

    for (let hora = horaInicioMadrid; hora <= horaFinMadrid; hora++) {
      if (horasInhabiles.includes(hora)) {
        conflictoInhabil = true;
        break;
      }
    }
  }

  let conflictoReserva = false;
  for (const reserva of reservasActivas) {
    const reservaInicio = new Date(reserva.fecha_hora_inicio);
    const reservaFin = new Date(reserva.fecha_hora_fin);

    if (hayConflictoConReserva(inicioReserva, finReserva, reservaInicio, reservaFin, margenAntes, margenDespues)) {
      conflictoReserva = true;
      break;
    }
  }

  if (!conflictoInhabil && !conflictoReserva) {
    return {
      estado: 'disponible',
      horaPropuesta: null,
      tipoConflicto: null
    };
  }

  const siguienteHueco = encontrarSiguienteHueco(
    inicioReserva,
    finReserva,
    reservasActivas,
    datosInhabiles?.datos?.[fechaReservaStr] || [],
    datosInhabiles,
    margenAntes,
    margenDespues
  );

  if (siguienteHueco) {
    return {
      estado: 'conflicto',
      horaPropuesta: siguienteHueco,
      tipoConflicto: conflictoInhabil ? 'inhabil' : 'reserva'
    };
  }

  return {
    estado: 'error',
    horaPropuesta: null,
    tipoConflicto: conflictoInhabil ? 'inhabil' : 'reserva'
  };
};

export const calcularFechaFin = (inicioReserva, duracionHoras = RESERVA_DURACION_HORAS) => {
  return new Date(inicioReserva.getTime() + duracionHoras * 60 * 60 * 1000);
};
